import React, { useEffect, useState } from "react";
import {
  Form,
  Row,
  Col,
  Select,
  Input,
  InputNumber,
  Button,
  Divider,
  Typography,
  Spin,
  Collapse,
  DatePicker,
} from "antd";
import "../../../Common/Form.css";
import { timezones } from "../../../../data/timezones";

const { Text } = Typography;
const { Option } = Select;

const ClassForm = (props) => {
  const { initialValues, onSubmit, status, type, setStatus } = props;
  const [isAddQuestionModalVisible, setIsAddQuestionModalVisible] = useState(
    false
  );

  const locationOptions = ["online", "classroom"].map((location) => (
    <Option value={location}>{location}</Option>
  ));

  const timezoneOptions = timezones.map((tz) => (
    <Option value={tz.name}>{`${tz.name} ${tz.offset}`}</Option>
  ));

  return (
    <div className="course-add-form">
      <Form
        labelCol={{ span: 7 }}
        onFinish={onSubmit}
        initialValues={initialValues}
      >
        <section>
          <Form.Item
            label="Class Code"
            name="classCode"
            rules={[{ required: true, message: "Please input class code!" }]}
          >
            <Input
              disabled={
                initialValues.classCode && initialValues.classCode !== ""
              }
            />
          </Form.Item>

          <Form.Item
            label="Max student count"
            name="maxVacancy"
            rules={[
              { required: true, message: "Please input number of students!" },
            ]}
          >
            <InputNumber defaultValue={500} />
          </Form.Item>

          <Form.Item label="Location" name="location">
            <Select placeholder="Select location">{locationOptions}</Select>
          </Form.Item>
        </section>

        <Row>
          <Col>
            <Form.Item
              label="Start"
              name="startDate"
              rules={[{ required: true, message: "Input start date!" }]}
            >
              <DatePicker showTime={true} showNow={false} />
            </Form.Item>
          </Col>

          <Col>
            <Form.Item
              label="End"
              name="endDate"
              rules={[{ required: true, message: "Input end date!" }]}
            >
              <DatePicker showTime={true} showNow={false} />
            </Form.Item>
          </Col>
        </Row>

        <section>
          <Form.Item label="Timezone" name="timezone">
            <Select placeholder="Select timezone">{timezoneOptions}</Select>
          </Form.Item>

          <Form.Item
            label="Class link"
            name="classLink"
            rules={[{ required: true, message: "Please input class link!" }]}
          >
            <Input />
          </Form.Item>
        </section>

        <Divider />

        {status.type === "ERROR" ? (
          <Text type="danger">{status.message}</Text>
        ) : null}
        {status.type === "SUCCESS" ? (
          <Text type="success">Sucessfully Updated!</Text>
        ) : null}
        <Row justify="end" gutter={12}>
          <Col>
            <Button type="primary" htmlType="submit">
              {type}
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default ClassForm;
